module.exports = __webpack_public_path__ + "static/logo-invert-15f86a5d62e007e2801d60c77068daa7.png";